import { Injectable, Injector, inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';
import { SubscriptionEntitlementService } from './subscription-entitlement.service';

@Injectable({ providedIn: 'root' })
export class AuthSessionService {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router, { optional: true });
  private readonly injector = inject(Injector);
  private redirectInProgress = false;
  private subscriptionRedirectInProgress = false;

  handleSessionExpired(): void {
    if (this.redirectInProgress) return;

    this.redirectInProgress = true;
    const redirect = this.auth.loginWithRedirect({
      appState: { target: this.router?.url ?? `${window.location.pathname}${window.location.search}` }
    });

    redirect.subscribe({
      error: () => {
        this.redirectInProgress = false;
      }
    });
  }

  handleSubscriptionRequired(): void {
    if (this.subscriptionRedirectInProgress) return;

    this.subscriptionRedirectInProgress = true;
    this.injector.get(SubscriptionEntitlementService).refresh();
    const navigation = this.router?.navigate(['/']);
    if (!navigation) {
      this.subscriptionRedirectInProgress = false;
      return;
    }
    void navigation.finally(() => this.subscriptionRedirectInProgress = false);
  }
}
